import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../../hook/useRulesContext";
import Input from "../../../../../../components/UI/Input";
import ButtonSet from "../../../../../../components/UI/ButtonSet";
import FieldWrapper from "../../../../../../components/UI/common/FieldWrapper";
import Wrapper from "../../../../../../components/UI/common/Wrapper";
import Errors from "../../../../../../components/Errors";

export default function BasicSettings() {
    const {
        shortcodeFormData: formData,
        userRoles: availableUserRoles,
        handleInputChange,
        qtyValidationMessages,
    } = useRulesContext();

    return (
        <>
            <FieldWrapper
                label={__(
                    "Rule Name *",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "This will be used to identify your quantity rule.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                width="100"
                direction="vertical"
                fieldsClass=""
            >
                <Input
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                />
            </FieldWrapper>
            <FieldWrapper
                label={__(
                    "Rule Priority",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Set the order in which rules are applied. Higher numbers are processed first.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                width="46"
                direction="vertical"
                fieldsClass=""
            >
                <Input
                    name="rule_priority"
                    value={formData.rule_priority}
                    onChange={handleInputChange}
                    required
                />
            </FieldWrapper>
            <FieldWrapper
                label={__(
                    "Apply To",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Choose the products to which this rule should be applied.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                direction="vertical"
                fieldsClass=""
            >
                <ButtonSet
                    name="apply_to"
                    value={formData.apply_to}
                    onChange={handleInputChange}
                    options={[
                        {
                            value: "all",
                            label: __(
                                "All",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "products",
                            label: __(
                                "Products",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "categories",
                            label: __(
                                "Categories",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "tags",
                            label: __(
                                "Tags",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                    ]}
                />
            </FieldWrapper>
            <Errors errors={qtyValidationMessages} />
            <Wrapper
                title={__(
                    "Quantity Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "You can adjust the quantity min, max, step and default quantity here.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                fieldsClass="grid grid-cols-1 lg:grid-cols-4 lg:gap-10 gap-6 p-4"
            >
                <FieldWrapper
                    label={__(
                        "Minimum Quantity",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    help={__(
                        "The minimum quantity that a user can add to their cart.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                    width="46"
                >
                    <Input
                        name="min_quantity"
                        type="number"
                        value={formData.min_quantity}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
                <FieldWrapper
                    label={__(
                        "Maximum Quantity",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    help={__(
                        "The maximum quantity that a user can add to their cart.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                    width="46"
                >
                    <Input
                        name="max_quantity"
                        type="number"
                        value={formData.max_quantity}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
                <FieldWrapper
                    label={__(
                        "Step",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    help={__(
                        "Step Increment - Define how much the quantity increases or decreases with each click. Example: Step = 1 allows 1, 2, 3... | Step = 5 allows 5, 10, 15...",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                    width="46"
                >
                    <Input
                        name="step"
                        type="number"
                        value={formData.step}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
                <FieldWrapper
                    label={__(
                        "Default Quantity",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    help={__(
                        "Default Quantity - The initial quantity value displayed when customers view the product.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                    width="46"
                >
                    <Input
                        name="default_quantity"
                        type="number"
                        value={formData.default_quantity}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
            </Wrapper>
        </>
    );
}
